'use strict';

var App = require('app');
var Consts = require('consts');
var AbstractFormView = require('components/common/views/abstract_form_view');
var i18n = require('utils/i18n');
var Jobs = require('models/jobs');
var Misc = require('utils/misc');
var Notification = require('utils/notification');
var Utils = require('components/common/utils');

var ControllerBackupDialog = AbstractFormView.extend({
    template: require('components/devices/templates/controller/backup_dialog'),

    ui: {
        btnApply: '#js-apply',
        note: '#js-note',
        backupList: '#df-backups',
        downloadList: '#df-downloads',
    },

    events: {
        'click .js-toggleMode': 'btnUpdate',
        'change .selectpicker': 'btnUpdate',
        'click @ui.btnApply': 'apply',
    },

    initialize: function (options) {
        this.deviceID = options.device;
        this.type = options.type;
        this.controller = options.controller;
        this.files = options.files;

        this.ownBackups = _.filter(
            this.files,
            function (f) {
                return f.device_id === this.deviceID;
            },
            this
        );
        this.otherBackups = _.filter(
            this.files,
            function (f) {
                return f.device_id !== this.deviceID;
            },
            this
        );

        this.panel = 'js-panel-save';
    },

    serializeData: function () {
        return {
            type: this.type,
            ownBackups: this.ownBackups,
            otherBackups: this.otherBackups,
        };
    },

    btnUpdate: function (e) {
        var isDisabled = true;
        if (e.target.id === this.panel) {
            // panel was collapsed
            this.panel = '';
        } else if (e.target.id.startsWith('js-panel')) {
            // panel was expanded
            this.panel = e.target.id;
            isDisabled = false;
        }

        if (this.panel === 'js-panel-restore') {
            isDisabled = this.ui.backupList.val() === '';
        }
        if (this.panel === 'js-panel-download') {
            isDisabled = this.ui.downloadList.val() === null;
        }

        Misc.setDisabled(this.ui.btnApply, isDisabled);
    },

    apply: function () {
        var jobArgs = { arguments: { device_id: this.deviceID } };

        if (this.panel === 'js-panel-download') {
            // download file
            var ids = this.ui.downloadList.val();
            var url = '/api/v1/controller-backups?download=' + this.deviceID + '&id=' + ids.join('&id=');

            var a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            document.body.appendChild(a);
            a.click();
            a.remove();

            App.hideModal();
            return;
        } else if (this.panel === 'js-panel-save') {
            // create backup
            jobArgs.arguments['annotation'] = this.ui.note.val();
            jobArgs.action = 'CREATE_CONTROLLER_BACKUP';
        } else {
            // restore backup
            jobArgs.arguments['backup_id'] = parseInt(this.ui.backupList.val());
            jobArgs.action = 'RESTORE_CONTROLLER_BACKUP';
        }

        this.job = new Jobs.Job(jobArgs);

        // restore job? -> ask for confirmation
        if (jobArgs.action == 'RESTORE_CONTROLLER_BACKUP') {
            var self = this;
            Utils.showConfirmationDialog({
                title: i18n.TR('Backup einspielen'),
                hint: Consts.DeviceUpdateHint,
                action_label: i18n.TR('Ausführen'),
                action_cb: function () {
                    App.hideModal();

                    // short delay to hide the disclaimer dialog
                    setTimeout(function () {
                        self.startJob(i18n.TR('Backup einspielen'));
                    }, 500);
                },
            });
            return;
        } else {
            this.startJob(i18n.TR('Backup erstellen'));
        }
    },

    startJob: function (header) {
        var self = this;
        $.when(this.controller.createBackupJob(this.job))
            .done(function (resp) {
                self.job.jobID = resp.jobID;
                self.pollJob();
                Utils.showConfirmationDialog({
                    title: header,
                    hint:
                        header +
                        ' ... <i class="fa fa-spin fa-spinner"></i>' +
                        '<br><div class="progress progress-lg"><div id="js-backup-progress" class="progress-bar progress-bar-info progress-bar-striped active" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="0" style="width: 0%;">0 %</div></div>' +
                        i18n.TR('Der Vorgang wird im Hintergrund ausgeführt.') +
                        ' ' +
                        i18n.TR('Sie können den Dialog schließen.'),
                    action_cb: function () {},
                });
            })
            .fail(function () {
                Notification.show('error', i18n.TR('Fehler'), i18n.TR('Vorgang konnte nicht gestartet werden.'));
            });
    },

    pollJob: function () {
        var msgSuccess =
            this.job.action === 'CREATE_CONTROLLER_BACKUP'
                ? i18n.TR('Backup der Konfiguration abgeschlossen.')
                : i18n.TR('Einspielen des Backups abgeschlossen.');
        var msgError =
            this.job.action === 'CREATE_CONTROLLER_BACKUP'
                ? i18n.TR('Backup der Konfiguration fehlgeschlagen.')
                : i18n.TR('Einspielen des Backups fehlgeschlagen.');

        var self = this;
        var $progress = $('#js-backup-progress');

        $.when(this.job.fetch())
            .done(function () {
                switch (self.job.get('state')) {
                    case 'DONE': {
                        $progress.css('width', '100%');
                        $progress.html('100 %');

                        App.hideModal();
                        Notification.show('success', i18n.TR('Erfolg'), msgSuccess);
                        break;
                    }
                    case 'RUNNING': {
                        var progress = self.job.get('progress');
                        if (typeof progress != 'object') {
                            $progress.css('width', progress + '%');
                            $progress.html(progress + ' %');
                        }

                        setTimeout(self.pollJob.bind(self), 2000);
                        break;
                    }
                    default: {
                        App.hideModal();
                        Notification.show('error', i18n.TR('Fehler'), msgError);
                    }
                }
            })
            .fail(function () {
                Notification.show(
                    'error',
                    i18n.TR('Fehler'),
                    i18n.TR('Der Vorgang konnte nicht abgeschlossen werden.')
                );
            });
    },

    selectLatest: function (e) {
        for (var i = 0; i < this.ownBackups.length; i++) {
            var isSelected = i == 0 || this.ownBackups[i].device_id != this.ownBackups[i - 1].device_id;

            var $el = $('#collapse3 ul li').eq(i);
            var $opt = $('#collapse3 select option').eq(i);

            $el.toggleClass('selected', isSelected).find('a').attr('aria-selected', isSelected);
            $opt.prop('selected', isSelected);
        }

        var title = $('.js-filter-multiselect.open ul.dropdown-menu.inner li.selected')
            .map(function () {
                return $(this).text();
            })
            .toArray()
            .join(', ');

        var $button = $('.js-filter-multiselect.open button.btn.dropdown-toggle.btn-white.btn-sm');
        $button.attr('title', title);
        $button.children('.filter-option').text(title);
        $button.removeClass('bs-placeholder');

        e.stopPropagation();
        this.btnUpdate(e);
    },

    customizeMultiSelectpicker: function () {
        var button =
            '<button type="button" class="actions-btn js-select-latest btn btn-default">' +
            i18n.TR('Neueste') +
            '</button>';

        $('button.bs-select-all').after(button);
        $('#modal button.actions-btn').addClass('btn-selectpicker-3');
        $('#modal button.js-select-latest').click(this.selectLatest.bind(this));
    },

    onShow: function () {
        Misc.initSelectPicker();
        this.customizeMultiSelectpicker();
    },
});

module.exports = ControllerBackupDialog;
